import { type ListBoxSectionItem } from '@direct-frontend/components';
import { type OpenApiSchemaMenuPossibleCollectionLink } from '#shared/api/schema';
import { AutomaticCollectionsHelp } from '#shared/components/AutomaticCollectionsHelp';
import { MenuItemLinkTypeIcon } from '../constants';

const mapCollectionToOption = ({ id, title }: OpenApiSchemaMenuPossibleCollectionLink) => {
    return { value: id, label: title, content: title };
};

type InternalCollectionLinkSection = ListBoxSectionItem<'collection' | 'collection-auto', string>;

export const splitMenuCollectionsToSections = (
    collections: OpenApiSchemaMenuPossibleCollectionLink[]
): InternalCollectionLinkSection[] => {
    const automaticOptions: ReturnType<typeof mapCollectionToOption>[] = [];
    const regularOptions: ReturnType<typeof mapCollectionToOption>[] = [];

    for (let i = 0; i < collections.length; i++) {
        const collection = collections[i];
        const option = mapCollectionToOption(collection);

        if (collection.is_automatic) {
            automaticOptions.push(option);
        } else {
            regularOptions.push(option);
        }
    }

    const sections: InternalCollectionLinkSection[] = [];

    if (regularOptions.length > 0) {
        sections.push({
            key: 'collection',
            title: 'Коллекции',
            icon: MenuItemLinkTypeIcon.collection,
            options: regularOptions,
        });
    }

    if (automaticOptions.length > 0) {
        sections.push({
            key: 'collection-auto',
            title: 'Автоматические коллекции',
            icon: MenuItemLinkTypeIcon.collection,
            help: AutomaticCollectionsHelp,
            options: automaticOptions,
        });
    }

    return sections;
};
